<template>
	<div class="page">
		<div class="form-title">
			<span>物流查询</span>
			<img class="logo" src="../assets/logo.44a85025.png" />
		</div>
		<div class="form-content">
			<el-form ref="dForm" :inline="true" label-width="90px">
				<el-form-item >
					<el-input style="width: 40vw;" type="textarea"  :rows="4" size="mini" placeholder="箱号/订单号/出仓单号(多个单号、请使用逗号、空格或者换行隔开)" v-model="id" @keyup.native.enter="searchInfo"
						clearable></el-input><el-button style="margin-left: 10px;height: 40px;" type="primary" size="mini"
						@click="searchInfo">搜索</el-button>
				</el-form-item>
			</el-form>
			<el-tabs v-model="activeName">
				<el-tab-pane label="路由信息" name="0" style="position: relative;height: 100%;padding-top: 20px;">
					<el-collapse accordion v-if="routeTableData.length > 0">
						<el-collapse-item v-for="(item0, index) in routeTableData" :key="index + 'a'">
							<template slot="title">
								<div style="display: flex;justify-content: space-around;height: 100%;width: 100%;">
									<div style="text-align: center;line-height: 46px;">
										<el-button style="margin-left: 10px;" type="primary" size="mini">物流轨迹</el-button>
									</div>
									<div>
										<p>出仓单号</p>
										<p>{{ item0.outNumber }}</p>
									</div>
									<div>
										<p>业务单号</p>
										<p>{{ item0.id }}</p>
									</div>
								</div>
							</template>
							<el-timeline v-if="item0.trackMasters.length > 0" style="overflow: auto;height: 490px;">
								<el-timeline-item style="position: relative;" :icon="item.icon" :color="item.color"
									:size="item.size" :timestamp="$moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')"
									placement="top" v-for="(item, index) in item0.trackMasters" :key="index">
									<p style="margin:0;">{{ item.message }}</p>
								</el-timeline-item>
							</el-timeline>
							<p v-else
								style="text-align: center;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);">
								暂无信息
							</p>
						</el-collapse-item>
					</el-collapse>

				</el-tab-pane>
				<el-tab-pane label="末端派送信息" name="1">
					<el-table border :data="tableData" height="500">
						<el-table-column align="center" prop="labelId" label="箱号" min-width="240">
						</el-table-column>
						<el-table-column align="center" prop="logisticCode" label="物流单号" min-width="240">
						</el-table-column>
						<el-table-column align="center" prop="latestStatus" label="状态" min-width="120">
							<template slot-scope="{row}">
								{{ row.latestStatus == 'Delivered' ? `成功签收&nbsp;&nbsp;&nbsp;&nbsp;
								${$moment(+row.deliverTime *
									1000).format('YYYY-MM-DD ')}` : '运输途中' }}
							</template>
						</el-table-column>
						<el-table-column type="expand" width="50" label="详情">
							<template slot-scope="props">
								<el-timeline v-if="props.row.tracks.length">
									<el-timeline-item v-for="(activity, index) in props.row.tracks" :key="index"
										:color="index == 0 ? '#0bbd87' : ''"
										:timestamp="$moment(+activity.time * 1000).format('YYYY-MM-DD HH:mm:ss')">
										{{ activity.description }}
									</el-timeline-item>
								</el-timeline>
								<p v-else style="text-align: center;">
									暂无详情
								</p>
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
			</el-tabs>

		</div>

	</div>
</template>

<script>
import { getTrack, queryTrack } from '@/api/home'
export default {
	name: 'HomeView',
	data() {
		return {
			activeName: '0',
			tableData: [],
			routeTableData: [],
			amount: '',
			id: '',
			flag:false
		}
	},
	created() {
	},
	watch: {
		activeName: function (newVal) {
			if (newVal == '1'&&this.flag) {
				this.getTrack()
			}
		}
	},
	methods: {
		//查询箱子信息
		queryTrack(id) {
			queryTrack({
				ids: [id]
			}).then((res) => {
				if (res.status == 200) {
					this.$message.success(res.data.message)
					res.data.result.forEach(item0 => {
						item0 = item0.trackMasters.map((item, index) => {
							if (index == 0) {
								item.icon = 'el-icon-s-order'
								item.color = 'blue'
							} else if (item.message == '交仓完成') {
								item.icon = 'el-icon-circle-check'
								item.color = 'green'
							} else {
								item.icon = 'el-icon-more'
								item.color = this.getRandomColor()
							}
							item.size = 'large'
							return item
						})
					})
					this.flag=true
					this.routeTableData = res.data.result
				} else {
					this.routeTableData = []
				}
			})
		},
		getRandomColor() {
			var letters = '0123456789ABCDEF';
			var color = '#';
			for (var i = 0; i < 6; i++) {
				color += letters[Math.floor(Math.random() * 16)];
			}
			return color;
		},
		//搜索
		searchInfo() {
			this.queryTrack(this.id)
		},
		//查询路由信息
		getTrack() {
			getTrack({
				companyId: 0,
				end: 0,
				id: this.id,
				page: 1,
				rows: 10,
				start: 0,
				userId: 0
			}).then((res) => {
				if (res.status == 200) {
					this.$message.success(res.data.message)
					this.tableData = res.data.result
				} else {
					this.tableData = []
				}
			})
		}
	},

}
</script>

<style scoped>
.page {
	width: 100vw;
	min-width: 1100px;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
}

.head {
	width: 100%;
	min-width: 1100px;
	height: 12px;
	background: #0166ff;
}

.logo {
	width: 221px;
	position: relative;
	left: -350px;
	top: 25px;

}

.el-input {
	width: 450px;
	float: left;
}

.el-radio-group {
	float: left;
	line-height: 50px;
}

.huowu-message {
	width: 100%;
	display: flex;
}

.huowu-message .el-input {
	width: 150px;
	float: right;
	margin-right: 20px;
}

.el-select {
	float: left;
}

::v-deep .el-tabs__header {
	margin: 0;
}

::v-deep .el-tabs__content {
	height: 460px;
	border: 1px solid #ccc;
}

::v-deep .el-table__body-wrapper {
	height: 442px !important;
}

.form-title {
	width: 60%;
	font-size: 22px;
	color: #333;
	line-height: 1;
	padding-bottom: 20px;
	border-bottom: 1px solid #ccc;
	margin: 30px 0 20px 0;
	text-align: left;
	font-weight: 600;
}



.form-content {
	width: 60%;
}

.input-address {
	display: flex;
	width: 100%;
	position: relative;
	left: -90px;

}

::v-deep .el-timeline {
	max-height: 385px;
}
p {
	margin: 0;
	padding: 0;
}
::v-deep .el-collapse-item__header{
	line-height: 22px;
}
::v-deep .el-form-item__content {
	display: flex !important;
    align-items: center;
}
</style>
